// Map composite score (0-100) to a sell-side-style rating label.
// Thresholds chosen to match the score's existing palette breakpoints
// (35 / 65) plus stronger calls at 20 / 80.

export type Rating = "Strong Sell" | "Sell" | "Hold" | "Buy" | "Strong Buy";

export function ratingFromScore(score: number | null | undefined): Rating | null {
  if (score === null || score === undefined || Number.isNaN(score)) return null;
  if (score >= 80) return "Strong Buy";
  if (score >= 60) return "Buy";
  if (score > 40) return "Hold";
  if (score > 20) return "Sell";
  return "Strong Sell";
}

export function ratingShort(r: Rating | null): string {
  switch (r) {
    case "Strong Buy": return "S.BUY";
    case "Buy": return "BUY";
    case "Hold": return "HOLD";
    case "Sell": return "SELL";
    case "Strong Sell": return "S.SELL";
    default: return "—";
  }
}

export function ratingClasses(r: Rating | null): string {
  switch (r) {
    case "Strong Buy":
      return "bg-emerald-500/20 text-emerald-200 ring-emerald-500/40";
    case "Buy":
      return "bg-emerald-500/10 text-emerald-300 ring-emerald-500/30";
    case "Hold":
      return "bg-slate-500/10 text-slate-300 ring-slate-500/30";
    case "Sell":
      return "bg-rose-500/10 text-rose-300 ring-rose-500/30";
    case "Strong Sell":
      return "bg-rose-500/20 text-rose-200 ring-rose-500/40";
    default:
      return "bg-slate-800 text-slate-500 ring-slate-700";
  }
}
